export function deleteItem(data) {
    let { deleteItemRequest, deleteItemError, deleteItemResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_item',
        this.createBundle('delete_item', { item: data }, this.POST, deleteItemRequest, deleteItemResult, deleteItemError)
    )
}
